import { render } from "./WeekendContentSection.vue?vue&type=template&id=2d3a2dab&scoped=true"
import script from "./WeekendContentSection.vue?vue&type=script&lang=js"
export * from "./WeekendContentSection.vue?vue&type=script&lang=js"

import "./WeekendContentSection.vue?vue&type=style&index=0&id=2d3a2dab&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3a2dab"]])

export default __exports__